/**
 * Notice — a centered full-page message used when there's no offer data to show
 * (a failed/invalid `uuid`, an expired link, or an empty result). Replaces the
 * old behaviour of silently rendering mock data on a failed live fetch.
 *
 * Props:
 *   - title {string} — short headline
 *   - body  {string} — explanatory sentence
 */
import React from 'react';

export default function Notice({ title, body }) {
    return (
        <div className="rs-proto">
            <div className="rs-notice">
                <h2 className="rs-notice__title">{title}</h2>
                <p className="rs-notice__body">{body}</p>
            </div>
        </div>
    );
}
